import React from 'react'
import './Filters.scss'
import SearchIcon from '@mui/icons-material/Search'
import FilterListIcon from '@mui/icons-material/FilterList'
import { Button, ButtonGroup } from '@mui/material'

const Filters = ({ selectedPage, setSelectedPage }) => {
  return (
    <div className='filters'>
      <div className='filters__left'>
        <ButtonGroup variant='contained' aria-label='Basic button group'>
          <Button onClick={() => setSelectedPage('List')} disabled={selectedPage === 'List'}>
            List
          </Button>
          <Button onClick={() => setSelectedPage('Routes')} disabled={selectedPage === 'Routes'}>
            Routes
          </Button>
          <Button onClick={() => setSelectedPage('Map')} disabled={selectedPage === 'Map'}>
            Map
          </Button>
        </ButtonGroup>
        <button className='filters__button'>📩</button>
        <input className='filters__search' placeholder='Search' />
        <SearchIcon className='filters__icon' />
      </div>
      <div className='filters__right'>
        <FilterListIcon className='filters__icon clickable' />
        <button className='filters__button editable' />
      </div>
    </div>
  )
}

export default Filters
